export enum RxdbCollectionName {
  WORK_PACKAGES = 'work_packages',
  INSPECTION_LIST = 'inspection_list',
  ASSET_DETAILS = 'asset_details',
  WORK_PACKAGE_FILES = 'work_package_files',
  INSPECTION_FILES = 'inspection_files',
  PREVIOUS_REPORTS_FILES = 'previous_reports_files',
  DEFICIENCY_LIST = 'deficiency_list',
  DEFICIENCY_ACTIONED_LIST = 'deficiency_actioned_list',
  RISK_ASSESSMENT = 'risk_assessment',
  DEFICIENCY_FILES = 'deficiency_files',
  REMEDIAL_ACTION = 'remedial_action',
  PRIMARY_CAUSE_OF_FAILURE = 'primary_cause_of_failure',
  CONDITION_RATING = 'condition_rating',
  OPERATIONAL_DOWNTIME = 'operational_downtime',
  TRAFFIC_SAFETY_SCORE = 'traffic_safety_score',
  URGENCY = 'urgency',
  COMPONENT_TYPE = 'component_type',
  COMPONENT_CHECKLIST = 'component_checklist',
  ASSETS_BY_AREA_HEIRACHY = 'assets_by_area_heirachy',
  PM_CHECKLIST = 'pm_checklist',
  SAVE_PMCHECKLIST = 'save_pmchecklist',
  ENVIRONMENTAL_CONDITION = 'environmental_condition',
  REPAIR_FACTOR = 'repair_factor',
  VIEW_INSPECTOR = 'view_inspector',
  TASK_LIST = 'task_list',
  NOTIFICATION = 'notification',
  SIGN_AND_STAMP_FILE = 'sign_and_stamp_file',
  PREVIOUS_TASK_COMMENTS = 'previous_task_comments',
  DEFICIENCY_COMMENTS = 'deficiency_comments',
  SIGN_AND_STAMP_USER_CONSENT = 'sign_and_stamp_user_consent',
  SIGN_AND_STAMP_USER_LEVEL = 'sign_and_stamp_user_level',
  ELEVATION_RANGE = 'elevation_range',
  PLANNED_DEFICIENCY_LIST = 'planned_deficiency_list',
  PLANNED_DEFICIENCY_FILES = 'planned_deficiency_files',
  LINE_AND_SECTION_PROPERTIES_LIST = 'line_and_section_properties_list',
  ASSET_SECTION_DEFINATIONS_LIST = 'asset_section_definations_list',
  COMPONENT_REMOVAL_CATEGORIES = 'component_removal_categories',
  DEFICIENCY_COMPONENT_REMOVAL = 'deficiency_component_removal',
  DEFICIENCY_COMPONENT_REMOVAL_VERSION = 'deficiency_component_removal_version',
  DEFICIENCY_VERSION_COMMENTS = 'deficiency_version_comments',
  DEFICIENCY_VERSION_FILES = 'deficiency_version_files',
}

export default { RxdbCollectionName };
